import { render, staticRenderFns } from "./PayCloudStorageMapping.vue?vue&type=template&id=569e0f54&scoped=true&"
import script from "./PayCloudStorageMapping.vue?vue&type=script&lang=js&"
export * from "./PayCloudStorageMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569e0f54",
  null
  
)

export default component.exports